export const maxInputValue = {
  data () {
    return {
      MX_maxInputValue: 2000
    }
  }
};
